export default __webpack_public_path__ + "static/media/studentModalStudy.6e14a19d.svg";